import { render, staticRenderFns } from "./LabelTextInput.vue?vue&type=template&id=96ed1130&scoped=true&"
import script from "./LabelTextInput.vue?vue&type=script&lang=js&"
export * from "./LabelTextInput.vue?vue&type=script&lang=js&"
import style0 from "./LabelTextInput.vue?vue&type=style&index=0&id=96ed1130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ed1130",
  null
  
)

export default component.exports